import { TabConfig, TabItem } from './tabsConfig';
import { CardTramiteProps } from '../CardTramite';

export const getModel = (item: TabItem, tramite: any, tabId: string) => {
  if (item.key === 'otros') {
    return {
      ...tramite,
      otros: (tramite.otros ?? []).find((o: any) => o.categoria === tabId)
    }
  }
  return tramite;
};

export const getCardTramiteProps = (item: TabItem, tab: TabConfig, tramite: any): CardTramiteProps => {
  if (item.key === 'otros') {
    const model = getModel(item, tramite, tab.id);
    return {
      title: model.otros?.nombre || item.title,
      href: item.href,
      disabled: !model.otros?.habilitado,
      visible: item.visible,
      model: model,
      categoria: tab.id,
      subtramite: model.otros,
      canActivate: item.canActivate ?? false,
      canChangeName: item.canChangeName ?? true,
    }
  }

  return {
    title: item.title,
    href: item.href,
    disabled: item.disabled,
    visible: item.visible,
    model: tramite,
    subtramite: tramite[item.key],
    canActivate: item.canActivate ?? false,
  }
};

export const hasActiveItems = (tab: TabConfig, tramite: any) => {
  if (!tab.items) return false;

  const activeCount = tab.items.filter((item: TabItem) => {
    const cardProps = getCardTramiteProps(item, tab, tramite);
    return cardProps.visible && !cardProps.disabled;
  }).length;

  return activeCount > 0;
};

export const getActiveCount = (items: TabItem[] = [], tab: TabConfig, tramite: any): number | null => {
  return items.filter(item => {
    const cardProps = getCardTramiteProps(item, tab, tramite);
    return cardProps.visible && !cardProps.disabled;
  }).length;
};

export const getTotalCount = (items: TabItem[] = [], tab: TabConfig, tramite: any): number | null => {
  return items.filter(item => {
    const cardProps = getCardTramiteProps(item, tab, tramite);
    return cardProps.visible;
  }).length;
};

export const getFilteredTabs = (
  tabsConfig: TabConfig[],
  canManageTramites: boolean,
  tramite: any
): TabConfig[] => {
  return tabsConfig.filter(tab => {
    if (canManageTramites) {
      return true;
    }

    if ('canActivate' in tab && tab.canActivate) {
      return tab.visible;
    }

    // Tabs with Component property (like comentarios, documentos) should be visible if user has permission
    if (tab.Component) {
      return tab.visible;
    }

    return tab.visible && hasActiveItems(tab, tramite);
  });
};

export const getDefaultTab = (
  defaultTab: string,
  visibleTabs: TabConfig[],
  canManageTramites: boolean
): string => {
  if ((defaultTab === 'comentarios' || defaultTab === 'documentos') && !canManageTramites) {
    return visibleTabs.length > 0 ? visibleTabs[0].id : 'certificados';
  }
  return defaultTab;
};